import { Box, Button, Card, CardActions, CardContent, CardHeader, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Stack, useMediaQuery, useTheme } from '@mui/material'
import PlanDetailsCard from '../AccountSubscription/PlanDetailsCard'
import TasksCountCard from '../AccountSubscription/TasksCountCard'
import { useTranslation } from 'react-i18next'
import MerchantBalanceCard from './MerchantBalanceCard'
import { useGetSubscriptionForMerchantByAdminQuery } from 'src/_api/planApi'
import { useState } from 'react'
import TitleInfoStack from '../AccountSubscription/TitleInfoStack'
import TaskExtraPriceAndSmsCard from '../AccountSubscription/TaskExtraPriceAndSmsCard'

export default function MerchantSubscriptionAndWalletCard({
    wallet,
    merchantId,
    profileRefetch
}) {
    const { t } = useTranslation()
    const theme = useTheme()
    const fullScreen = useMediaQuery((theme) => theme.breakpoints.down("md"))

    const {
        data: subscriptionInfo,
        isLoading: subscriptionInfoLoading
    } = useGetSubscriptionForMerchantByAdminQuery(merchantId)

    const [open, setOpen] = useState(false)

    return (
        <>
            <Card>
                <CardHeader title={t("Subscription / Wallet Balance")} />
                <Divider />
                <CardContent>
                    <Box display="flex" justifyContent="space-between" alignItems="center" gap={2}>
                        {
                            !!subscriptionInfo?.plan &&
                            <TitleInfoStack
                                title={t("Plan")}
                                value={theme.direction === 'rtl' ? subscriptionInfo?.plan?.name_ar : subscriptionInfo?.plan?.name_en}
                            />
                        }
                        <TitleInfoStack
                            title={t("Wallet Balance")}
                            value={wallet?.balance?.toFixed(2)}
                        />
                    </Box>
                </CardContent>
                <Divider />
                <CardActions>
                    <Box mr="auto" />
                    <Button
                        variant="contained"
                        sx={{ textTransform: "none" }}
                        onClick={() => setOpen(true)}
                    >
                        {t("More Details")}
                    </Button>
                </CardActions>
            </Card>
            <Dialog
                open={open}
                onClose={(e) => e.preventDefault()}
                maxWidth="md"
                fullWidth
                fullScreen={fullScreen}
            >
                <DialogTitle>
                    {t("Subscription / Wallet Balance")}
                </DialogTitle>
                <Divider />
                <DialogContent>
                    <Stack spacing={3}>
                        <MerchantBalanceCard
                            wallet={wallet}
                            merchantId={merchantId}
                            profileRefetch={profileRefetch}
                        />
                        {
                            !!subscriptionInfo?.plan &&
                            <>
                                <PlanDetailsCard
                                    subscriptionInfo={subscriptionInfo}
                                    loading={subscriptionInfoLoading}
                                    hideActions={true}
                                />
                                <TasksCountCard
                                    subscriptionInfo={subscriptionInfo}
                                    loading={subscriptionInfoLoading}
                                    credits={wallet?.balance}
                                    hideActions={true}
                                />
                                <TaskExtraPriceAndSmsCard
                                    subscriptionInfo={subscriptionInfo}
                                    merchantId={merchantId}
                                />
                            </>
                        }
                    </Stack>
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button
                        variant="contained"
                        sx={{ textTransform: "none" }}
                        onClick={() => setOpen(false)}
                    >
                        {t("Close")}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
